
import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";

// import * as api from "../constant/API";
import { Link } from "react-router-dom";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const Sports = () => {

    const [searchInput, setSearchInput] = useState("");
    const [sprtList, setSprtList] = useState([]);
    const [sportName, setSportName] = useState('');
    const [updateSportId, setUpdateSportId] = useState('');
    const [updateSportStatus, setUpdateSportstatus] = useState('');
    const [error, setError] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        sportList(null);
    }, [])

    function sportList(par: string | null) {
        let getSportList = api.SportList;
        if (par) {
            // getSportList += "?sportId=" + par
            getSportList += "/" + par
        }
        fetch(getSportList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (par) {
                        // const row = sprtResult.data[0];
                        const row = sprtResult.data;
                        setUpdateSportId(row.sportId)
                        setSportName(row.sportName)
                        setUpdateSportstatus(row.sportStatus)
                    }
                    else {
                        setSprtList(sprtResult.data);
                    }
                }
            })
            .catch((error) => {
                console.log('Failed to fetch the list of sports', error);
            })
    }

    function editSport(row) {
        const id = row.sportId;
        sportList(id);
        setIsEdit(true);
        setOpenModal(true);
    }

    function checkSport(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSport();
            } else {
                const checkNameSport = api.CheckSportName + '/' + sportName;//"?sportName=" + sportName;
                fetch(checkNameSport, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    }
                })
                    .then((checkResponse) => checkResponse.json())
                    .then((checkResult) => {
                        if (checkResult.error == true) {
                            if (checkResult.code == 401) {
                                Utils.logoutUser();
                            }
                            setError(checkResult.message)
                            Swal.fire(checkResult.message)
                        }
                        else {
                            setError("");
                            addSport();
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to check whether the name exists or not", error)
                    })
            }
        }
    }

    function addSport() {
        const formData = new FormData();
        formData.append("sportName", sportName);
        const addNewSport = api.CreateSport;
        fetch(addNewSport, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((addResponse) => addResponse.json())
            .then((addResult) => {
                if (addResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: addResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (addResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: addResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to add new Sport", error);
            })
    }

    function updateSport() {
        const formData = new FormData();
        formData.append("sportId", updateSportId);
        formData.append("sportName", sportName);
        formData.append("sportStatus", updateSportStatus);

        const updateSprt = api.UpdateSport;
        fetch(updateSprt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((updateResult) => {
                if (updateResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (updateResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the sport", error);
            })
    }

    const filteredData = sprtList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData) => {
        return <span>{rowData.sportName}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSport(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' ? (
                                            <>
                                                <div className="row col-md-12">
                                                    <div className="col-md-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); setSportName("") }}
                                                        >
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Sport
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportName"
                                                    header="Name"
                                                    body={nameRender}
                                                ></Column>

                                                {(roleId == '1' || roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/ Edit Sport */}
            {openModal &&
                <Modal
                    show={openModal}
                    size="md"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Sport</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="mb-10">
                                <label className="form-label">Sport</label>
                                <input
                                    id="sportName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={sportName}
                                    placeholder="Sport Name"
                                    required
                                    onChange={(e) => {
                                        setSportName(e.target.value)
                                    }}
                                />
                            </div>
                            {error && <div className="alert alert-danger">{error}</div>}
                            {
                                isEdit ?
                                    <>
                                        <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={updateSportStatus === '1'}
                                                    id="instistatus"
                                                    onChange={(e) => {
                                                        setUpdateSportstatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </> : null
                            }
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={checkSport}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            }
            {/* /Add/ Edit Sport */}


        </>
    );

};

export default Sports;